export interface IWarehouseState {
    getReleaseMaterialProductsSuccess : any;
    getReleaseMaterialProductsError : any;
    getReceiveProductSuccess : any;
    getReceiveProductError : any;
    getEditReceiveProductSuccess : any;
    getEditReceiveProductError : any;
    //reject material
    getAllRejectMaterialSuccess: any;
    getAllRejectMaterialError: any;
    getAddRejectMaterialSuccess: any;
    getAddRejectMaterialError: any;
    getEditRejectMaterial_productSuccess:any;
    getEditRejectMaterial_productError: any;
    getAddRejectProductSuccess: any;
    getAddRejectProductError: any;
    // getEditRejectProductSuccess:any;
    // getEditRejectProductError: any;
    getMlosSuccess: any;
    getMlosError: any;
   getRecLotsByMaterialIDSuccess: any;
   getRecLotsByMaterialIDError: any;
   getRecLotsByMaterialIDListSuccess: any;
   getRecLotsByMaterialIDListError: any;
    //return Material
    getAddReturnMaterialSuccess: any;
    getAddReturnMaterialError: any;
    getEditReturnMaterialSuccess: any;
    getEditReturnMaterialError: any;

    //receive Product
    getReceiveProductByFormulaIdSuccess: any;
    getReceiveProductByFormulaIdError: any;

    getReceivedQtyByFormulaIdSuccess :  any;
    getReceivedQtyByFormulaIdError :  any;

    getUpdateSohValueSuccess : any;
    getUpdateSohValueError : any;

    //miscellaneousReason
    getMiscellaneousReasonsSuccess:any;
    getMiscellaneousReasonsError:any
    addMiscellaneousReasonSuccess:any;
    addMiscellaneousReasonError:any

}
export const initialWarehouseState: IWarehouseState = {
    getReleaseMaterialProductsSuccess : null,
    getReleaseMaterialProductsError : null,
    getReceiveProductSuccess : null,
    getReceiveProductError : null,
    getEditReceiveProductSuccess : null,
    getEditReceiveProductError : null,
   //reject mat/prod
    getAllRejectMaterialSuccess: null,
    getAllRejectMaterialError: null,
    getAddRejectMaterialSuccess: null,
    getAddRejectMaterialError: null,
    getEditRejectMaterial_productSuccess:null,
    getEditRejectMaterial_productError:null,
    getAddRejectProductSuccess: null,
    getAddRejectProductError: null,
    // getEditRejectProductSuccess:null,
    // getEditRejectProductError: null,
    getMlosSuccess:null,
    getMlosError: null,
   getRecLotsByMaterialIDSuccess: null,
   getRecLotsByMaterialIDError: null,
  getRecLotsByMaterialIDListSuccess: null,
   getRecLotsByMaterialIDListError: null,
    //return Material
    getAddReturnMaterialSuccess:null,
    getAddReturnMaterialError: null,
    getEditReturnMaterialSuccess:null,
    getEditReturnMaterialError: null,

    //receive Product
    getReceiveProductByFormulaIdSuccess: null,
    getReceiveProductByFormulaIdError: null,

    getReceivedQtyByFormulaIdSuccess : null,
    getReceivedQtyByFormulaIdError :  null,

    getUpdateSohValueSuccess : null,
    getUpdateSohValueError : null,

    //miscellaneousReason
    getMiscellaneousReasonsSuccess:null,
    getMiscellaneousReasonsError:null,
    addMiscellaneousReasonSuccess:null,
    addMiscellaneousReasonError:null

};
